import ContactActions from "../common/ContactActions/ContactActions";
import Chat from "../chat/HeroChatBox/Chat";

export type ContactProps = {
  scheduleButtonHref?: string;
};

export default function Contact({ scheduleButtonHref = "/book-appointment" }: ContactProps) {
  return (
    <ContactActions scheduleButtonHref={scheduleButtonHref}>
      <Chat />
    </ContactActions>
  );
}